import {
    faArrowRightFromArc,
    faArrowRightToArc,
    faCameraCctv,
    faCashRegister,
    faCopy,
    faDisplay,
    faEdit,
    faKeyboard,
    faSidebarFlip,
    faSpinnerThird,
    faSquareParking,
    faTrashAlt,
    faWindow,
} from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

export const ICON_MAP = {
    DISPLAY_5D: faDisplay,
    DISPLAY_5D_M_BIG: faDisplay,
    DISPLAY_5D_M_SMALL: faDisplay,
    DISPLAY_5D_RGB_BIG: faDisplay,
    DISPLAY_B: faDisplay,
    DISPLAY_B_N: faDisplay,
    DISPLAY_COUNTER: faDisplay,
    DISPLAY_S_N: faDisplay,
    DISPLAY_SP123F: faDisplay,
    ENTRY_POINT: faArrowRightToArc,
    ENTRY_POINT_FITNESS: faArrowRightToArc,
    ENTRY_POINT_LPR: faArrowRightToArc,
    ENTRY_POINT_SP201: faArrowRightToArc,
    EXIT_POINT: faArrowRightFromArc,
    EXIT_POINT_FITNESS: faArrowRightFromArc,
    EXIT_POINT_LPR: faArrowRightFromArc,
    EXIT_POINT_SP201: faArrowRightFromArc,
    KEYBOARD: faKeyboard,
    LOCAL_WORK_STATION: faSquareParking,
    LPR_RUNNING_SERVICE: faCameraCctv,
    PAY_MASHINE: faCashRegister,
    PAY_MASHINE_ND: faCashRegister,
    PAY_MASHINE_VLD: faCashRegister,
    RUNNING_SERVICE: faWindow,
    VALIDATION_POINT: faSquareParking,
    VALIDATION_SOFT: faWindow,
    DELETE: faTrashAlt,
    EDIT: faEdit,
    SIDE_PANEL: faSidebarFlip,
    COPY: faCopy,
    ADD: faPlus,
    SPINNER: faSpinnerThird,
};
